import { render, staticRenderFns } from "./CoHtml.vue?vue&type=template&id=71a696c8&"
import script from "./CoHtml.vue?vue&type=script&lang=ts&"
export * from "./CoHtml.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports